import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Don't show error boundary for known Firestore internal errors
        const errorMessage = error?.message || error?.toString() || '';
        const errorStack = error?.stack || '';
        const fullError = errorMessage + ' ' + errorStack;
        
        // Only suppress specific known non-critical Firestore internal errors
        const isFirestoreInternal = 
            fullError.includes('INTERNAL ASSERTION FAILED') || 
            (fullError.includes('FIRESTORE') && fullError.includes('INTERNAL')) ||
            fullError.includes('TargetState.Ke') ||
            fullError.includes('WatchChangeAggregator');
        
        if (isFirestoreInternal) {
            // Return null to suppress the error UI for known internal errors
            return { hasError: false, error: null };
        }
        
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Only suppress specific known non-critical Firestore internal errors
        const errorMessage = error?.message || error?.toString() || '';
        const errorStack = error?.stack || '';
        const fullError = errorMessage + ' ' + errorStack;
        
        const isFirestoreInternal = 
            fullError.includes('INTERNAL ASSERTION FAILED') || 
            (fullError.includes('FIRESTORE') && fullError.includes('INTERNAL')) ||
            fullError.includes('TargetState.Ke') ||
            fullError.includes('WatchChangeAggregator');
        
        if (isFirestoreInternal) {
            // Silently suppress known Firestore internal errors
            console.warn('[Firestore Internal] Error suppressed by boundary (non-critical)');
            return;
        }
        
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-container">
                    <h2>Something went wrong</h2>
                    <button onClick={() => window.location.reload()}>
                        Refresh Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;